<template>
  <div class="w-100">
    <grid-component
        isResizable
        isReorderable
        :canEdit="checkClaim(CAN_EDIT_POS)"
        :canDelete="checkClaim(CAN_DELETE_POS)"
        :gridId="gridId"
        :itemData="itemData"
        :fields="fields"
        :onEdit="onEdit"
        :onDelete="onDelete"
        :navigationField="'partNumber'"
        :handleRowClick="onRowClick"
      />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
// import debounce from 'lodash/debounce';
import { date } from '@/shared/filters';

import { GRID_ID } from '@/shared/constants';
import { prepareColumnsData } from '@/shared/helpers';
import GridSettings from '@/shared/components/GridSettings';
import GridComponent from '@/shared/components/GridComponent';
import gridFields from './fields';

export default {
  components: {
    GridSettings,
    GridComponent
  },
  props: {
    purchaseOrderId: {
      type:  [Number, String],
      default: 0,
    },
    showAllGridRows: {
      type: [Boolean],
      default: false,
    },
    isSourceComponent: {
      type: Boolean,
      default: false,
    },
    isReceiveItemComponent: {
      type: Boolean,
      default: false,
    },
    isFilteredList: {
      type: Boolean,
      default: false,
    },
    purchaseOrderLinesFiltered: {
      type: Array,
      default: () => []
    },
    gridId: {
      type: String,
      default: GRID_ID.PURCHASE_ORDER_LINES
    },
    componentKey:{
      type:  [Number, String],
      default: 0,
    }
  },
  data: () => ({
    prepareColumnsData,
    selectedRowItemId: 0,
    date,
    fields: gridFields,
  }),
  computed: {
    ...mapGetters('account', ['gridSettingsById']),
    ...mapGetters('purchaseOrderLines', ['purchaseOrderLines']),
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    // sortDetails: function() {
    //   if (this.sortBy) {
    //     return [{ field: this.sortBy, dir: this.sortOrder.toLowerCase() }];
    //   }
    //
    //   if (this.gridSettings.sort) {
    //     return [
    //       {
    //         field: this.gridSettings.sort.sortBy,
    //         dir: this.gridSettings.sort.sortOrder.toLowerCase(),
    //       },
    //     ];
    //   }
    //
    //   return [];
    // },
    // purchaseOrderLines() {
    //   return this.purchaseOrderLinesById(this.purchaseOrderId);
    // },
    itemData() {
      let line = (this.isFilteredList) ? this.purchaseOrderLinesFiltered : this.purchaseOrderLines;

      if(line.length === 0) return [];

      return line.map((purchaseOrderLine) => ({ ...purchaseOrderLine, selected: purchaseOrderLine.id === this.selectedRowItemId }));
      //return this.purchaseOrderLines;
    },

  },
  methods: {
    ...mapActions('purchaseOrderLines', [
      'getPurchaseOrderLines',
      'getOpenPurchaseOrderLines',
      'deletePurchaseOrderLine'
    ]),
    // ...mapMutations('purchaseOrderLines', ['setPurchaseOrderLines']),
    ...mapActions('account', ['saveGridSettings']),
    onEdit(data) {
      this.$emit('showEdit', data);
    },
    // ...mapMutations('purchaseOrderLines', ['clearPurchaseOrderLines']),
    ...mapMutations('purchaseOrderLines', ['setItem']),
    onRowClick(row) {
      this.selectedRowItemId = row.dataItem.id;
      if (this.isSourceComponent) {
        this.$emit('selectedSourceObj', row.dataItem);
      }
    },
    async onDelete(item) {
      if (item.qtyReceived > 0) {
        this.openAlertBox({message: `You can not delete this item. This purchase order line has already been RECEIVED.`});
      } else {
        const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete purchase order line with id :${item.id}?`});
        if (deleteConfirmed) {
          const result = await this.deletePurchaseOrderLine(item);
          this.getPurchaseOrderLines(this.purchaseOrderId);
        }
      }
    },
    emitPurchaseOrderLine(newVal){
      let line = (this.isFilteredList) ? this.purchaseOrderLinesFiltered : this.purchaseOrderLines;

      const selectedRow = line.find(purchaseOrderLine => purchaseOrderLine.id === newVal);
      this.$emit('selectedPurchaseOrderLine', selectedRow);
    }
  },
  watch: {
    purchaseOrderId() {
      if(this.purchaseOrderId) {
        this.getPurchaseOrderLines(this.purchaseOrderId);
      } else {
        // this.clearPurchaseOrderLines();
        this.setItem({ resource: 'purchaseOrderLines', payload: [] });
        this.setItem({ resource: 'poLineWithInventory', payload: [] });
      }
    },
    purchaseOrderLines() {
      if(this.purchaseOrderLines.length > 0 && this.selectedRowItemId === 0 && !this.isReceiveItemComponent) {
        this.selectedRowItemId = this.purchaseOrderLines[0].id;
      }
    },
    selectedRowItemId(newVal) {
      // let line = (this.isFilteredList) ? this.purchaseOrderLinesFiltered : this.purchaseOrderLines;
      //
      // const selectedRow = line.find(purchaseOrderLine => purchaseOrderLine.id === newVal);
      // this.$emit('selectedPurchaseOrderLine', selectedRow);
      this.emitPurchaseOrderLine(newVal);
    },
    componentKey(){
      this.emitPurchaseOrderLine(this.selectedRowItemId);
    }
  },
  mounted() {
    if (this.isSourceComponent) {
      this.getOpenPurchaseOrderLines();
    }
    if(this.purchaseOrderId){
      this.getPurchaseOrderLines(this.purchaseOrderId);
    } else if (!this.purchaseOrderId) {
      // this.setPurchaseOrderLines([]);
      this.setItem({ resource: 'purchaseOrderLines', payload: [] });
    }
  },
};
</script>

<style scoped>
.sales-order-lines-grid {
  height: 185px !important;
}
</style>
